import styled from 'styled-components';

export const DeskTopImageGalleryContainer = styled('div')`
  display: block;
  overflow: scroll;
  scrollbar: hidden;
  /* Hide scrollbar for Chrome, Safari and Opera */

  &::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none;
  scrollbar-width: none;
`;

export const TwoColumnContainer = styled('div')`
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin-bottom: 0.2rem;
  grid-gap: 0.2rem;
`;

export const LivePreviewContainer = styled('div')`
  position: relative;
  padding-top: 100%;
  background: #f0f0f0;
`;

export const LivePreviewContainerInner = styled('div')`
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
`;

export const MobileImageGalleryContainer = styled('div')`
  position: relative;
  min-height: 224px;
`;

export const DesktopThumbnailGalleryContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 16px;
`;

export const MainImageContainer = styled.div`
  aspect-ratio: 1/ 1;
  width: 100%;
  margin-bottom: 16px;
  position: relative;
  overflow: hidden;
`;

export const MainImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
  cursor: zoom-in;
`;

export const ThumbnailsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(60px, 1fr));
  gap: 6px;
`;

export const Thumbnail = styled.div.withConfig({
  shouldForwardProp: (prop: string) => prop !== 'isActive'
})<{ isActive: boolean }>`
  aspect-ratio: 1 / 1;
  border-radius: 4px;
  cursor: pointer;
  overflow: hidden;
  border: 2px solid ${({ isActive }) => (isActive ? '#000' : 'transparent')};
  transition: border-color 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;

  img[src^="data:image/svg+xml"] {
    width: 40% !important;
    height: 40% !important;
    object-fit: contain;
    margin: 0;
  }

  &:has(img[src^="data:image/svg+xml"]) {
    background: #EFEFEF;
  }
`;
